import {
  OwnUpFillButtonSecondary,
  PropsWithTheme,
  WHITE_100
} from '@rategravity/own-up-component-library';
import React from 'react';
import styled from 'styled-components';
import { RefreshIcon } from '../../../../images/icons/refresh-icon';
import { useABComparison } from '../data/dataProvider';
import { ABComparisonDataActionsTypes } from '../types';
import { BasicInputs } from './basicInputs';

const InputsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  row-gap: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(4)}px;
  column-gap: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(9)}px;
  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.up('md')} {
    padding: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(3)}px;
    flex-direction: row;
  }
  background-color: ${WHITE_100};
  border-radius: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(1, 1)};
  padding: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(2)}px;
`;
const RightAlignedOptionWrapper = styled.div`
  text-align: right;
  background-color: ${WHITE_100};
  padding: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(2)}px;
  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.up('md')} {
    padding: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(3)}px;
    padding-top: 0;
  }
`;

export const Inputs = () => {
  const { dispatch } = useABComparison();
  const returnToDefaults = () => dispatch({ type: ABComparisonDataActionsTypes.SET_DEFAULTS });
  return (
    <>
      <InputsWrapper>
        <BasicInputs variant="A" />
        <BasicInputs variant="B" />
      </InputsWrapper>
      <RightAlignedOptionWrapper>
        <OwnUpFillButtonSecondary icon={<RefreshIcon />} onClick={returnToDefaults}>
          Return to defaults
        </OwnUpFillButtonSecondary>
      </RightAlignedOptionWrapper>
    </>
  );
};
